import axios from '../../axios'


// 新增保存
export const pubInformationCreate = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/pubInformationCreate',
    method: 'post',
    data
  })
}

// 上传图片
export const uploadImages = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/uploadImages',
    method: 'post',
    data
  })
}
// 编辑保存
export const updateByPrimaryKeySelective = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/commodity',
    method: 'post',
    data
  })
}

// 编辑保存
export const updateByPrimaryKey = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/update_by_primary_key',
    method: 'post',
    data
  })
}


// 删除
export const deleteByPrimaryKey = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/delete_by_primary_key',
    method: 'post',
    data
  })
}

// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/delete',
    method: 'post',
    data
  })
}



// 主键查询
export const selectByPrimaryKey = (id) => {
  return axios({
    url: '/berry-pub/pubInformation/select_by_primary_key',
    method: 'get',
    params:{id:id}
  })
}
// 主键扩展查询
export const selectWrapperByPrimaryKey = (id) => {
  return axios({
    url: '/berry-pub/pubInformation/select_wrapper_by_primary_key',
    method: 'get',
    params:{id:id}
  })
}

// 分页查询
export const selectListPage = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/select_list_page',
    method: 'post',
    data
  })
}

// 分页列表查询
export const selectListWrapperPage = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/select_list_wrapper_page',
    method: 'post',
    data
  })
}

// 列表查询
export const selectList = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/select_list',
    method: 'post',
    data
  })
}

// 列表扩展查询
export const selectListWrapper = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/select_list_wrapper',
    method: 'post',
    data
  })
}


// 查询商品关联树
export const findCommoditytTree = () => {
  return axios({
    url: '/berry-pub/pubInformation/findTree',
    method: 'get'
  })
}

export const findPage = (data) => {
  return axios({
    url: '/berry-pub/pubInformation/findPage',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/pub/Information.js